<template lang="pug">
  .export
    .box.mt-4
      h2 Kuu väljavõte
      .form
        b-form-select.input(v-model="month" :options="months")
        b-form-select.input(v-model="year" :options="years")
        b-button.input(variant="primary" @click='downloadDonations')
          | Lae alla annetused
          font-awesome-icon.ml-2(icon='download')
        b-button.input(variant="primary" @click='downloadMonthSignatures')
          | Lae alla allkirjad
          font-awesome-icon.ml-2(icon='download')
        b-button.input(variant="primary" @click='downloadOutstandingDonations')
          | Lae alla laekumata annetused
          font-awesome-icon.ml-2(icon='download')

      h2.mt-4 Kampaania kõikide allkirjade väljavõte
      .form
        b-form-select.input(:options='campaigns' v-model='selectedCampaign')
        b-button.input(variant='primary' :disabled='selectedCampaign === null' @click='downloadCampaignSignatures')
          | Lae alla
          font-awesome-icon.ml-2(icon='download')
</template>

<script>
import { authBackend } from '../api'

const monthNames = [
  'Jaanuar', 'Veebruar', 'Märts', 'Aprill', 'Mai', 'Juuni', 'Juuli',
  'August', 'September', 'Oktoober', 'November', 'Detsember'
]

async function download(url, parameters, filename) {
  const file = (await authBackend().get(
    url,
    {
      params: parameters,
      responseType: 'blob'
    }
  )).data
  const anchor = document.createElement('a')
  anchor.href = window.URL.createObjectURL(file)
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  window.URL.revokeObjectURL(anchor.href)
  document.body.removeChild(anchor)
}

export default {
  name: 'export',

  data() {
    const today = new Date()
    let years = []
    for (let year = 2017; year <= today.getFullYear(); ++year) {
      years.push(year)
    }
    let months = []
    for (let month = 0; month < 12; ++month) {
      months.push({ value: month, text: monthNames[month] })
    }
    return {
      months: months,
      years: years,
      month: today.getMonth(),
      year: today.getFullYear(),
      campaigns: [],
      selectedCampaign: null
    }
  },

  async created() {
    this.campaigns = (await authBackend().get('/api/signature/campaigns')).data
  },

  methods: {
    async downloadDonations() {
      await download(
        `${process.env.VUE_APP_BACKEND_URL}/api/donation/export`,
        {
          year: this.year,
          month: this.month + 1
        },
        'annetused.csv'
      )
    },

    async downloadOutstandingDonations() {
      await download(
        `${process.env.VUE_APP_BACKEND_URL}/api/donation/export/outstanding`,
        {
          year: this.year,
          month: this.month + 1
        },
        'laekumata_annetused.csv'
      )
    },

    async downloadMonthSignatures() {
      await download(
        `${process.env.VUE_APP_BACKEND_URL}/api/signature/export`,
        {
          year: this.year,
          month: this.month + 1
        },
        'allkirjad.csv'
      )
    },

    async downloadCampaignSignatures() {
      await download(
        `${process.env.VUE_APP_BACKEND_URL}/api/signature/${this.selectedCampaign}/export`,
        undefined,
        'allkirjad.csv'
      )
    }
  }
}
</script>

<style>
.export .form select {
  width: 150px;
}

.export .input {
  margin-right: 0.5rem;
}
</style>
